import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { FiChevronRight } from "react-icons/fi";
import { ManagePollForm } from "./managePollForm";
import { useSelector, useDispatch } from "react-redux";
import { ALLOW_ACCESS } from "../../../../constants/cms";
import {
    getPollFilterDeviceAction,
    getPollFilterPageTypeAction,
    getPollDomainTypeAction,
    getPollsDataAction,
    postPollsAction,
    putPollsAction,
    getPollFilterEntityNameAction,
    getPollFilterEntityTypeAction,
    getPollSubPageAction,
} from "../../../../../store/actions/cms/pollAction";
import { Alert } from "@mui/material";
import { clearMessage } from "../../../../../store/slices/pollSlice";
import { formatDateFor } from "../../../../utils/index";

export const ManagePolls = () => {
    const { id } = useParams();
    const dispatch = useDispatch();

    const [question, setQuestion] = useState("");
    const [endDate, setEndDate] = useState(null);
    const [startDate, setStartDate] = useState(null);
    const [visibleDate, setVisibleDate] = useState(null);
    const [isPublished, setIsPublished] = useState(false);
    const [showOnArticle, setShowOnArticle] = useState(false);
    const [showOnCollege, setShowOnCollege] = useState(false);
    const [deviceType, setDeviceType] = useState([]);
    const [show, setShow] = useState("");
    const [allowAccess, setAllowAccess] = useState("");
    const [options, setOptions] = useState(["", ""]);
    const [optionLengthErrors, setOptionLengthErrors] = useState({});
    const [mappings, setMappings] = useState([
        {
            page_type: "", entity_type: "", entity_name: [], show_on_article: false,
            show_on_college: false, sub_entity_id: ""
        },
    ]);
    const [showWarning, setWarning] = useState('')
    const [errors, setErrors] = useState({});
    const [keywordId, setKeywordId] = useState([]);
    const navigate = useNavigate();
    const urlPattern = /^https?:\/\/([a-zA-Z0-9-]+\.)?careers360\.[a-z]{2,6}(\/[^\s]*)?$/;
    const { user } = useSelector((state) => state.userData);
    const {
        getPollsData,
        pollDeviceFilterData,
        putPollError,
        postPollsError,
        putPollData,
        postPollsData,
        message,
        pollDomainTypeData,
        pollEntityNameFilterData,
        pollPageTypeFilterData,
        pollSubPageData,
        pollEntityTypeFilterData,
    } = useSelector((state) => state?.pollCreationReducer);

    useEffect(() => {
        dispatch(getPollFilterDeviceAction({ filter_type: "device_type" }));
        dispatch(getPollFilterPageTypeAction({ filter_type: "page_type" }));
        dispatch(getPollDomainTypeAction({ filter_type: "domain" }));
    }, []);

    useEffect(() => {
        if (id) {
            dispatch(getPollsDataAction({ poll_id: id }));
        }
    }, [id]);

    useEffect(() => {
        if (!mappings || !mappings.length) return;

        mappings.forEach((mapItem, index) => {
            const pageType = mapItem?.page_type?.value || mapItem?.page_type?.id;
            const entityType =
                mapItem?.entity_type?.value || mapItem?.entity_type?.id;

            let params = {};

            if (pageType) {
                params.page_type = pageType;

                if (pageType !== "Articles" && pageType !== "News") {
                    if (pageType === "College Detail Pages") {
                        params.entity_type = "college";
                    } else {
                        params.entity_type = entityType;
                    }

                    if (params.entity_type) {
                        dispatch(
                            getPollFilterEntityNameAction({
                                filter_type: "entity_name",
                                ...params,
                            })
                        );
                    }
                }
            }

            // if only entity changes .
            // if (entityType && pageType) {
            //   dispatch(
            //     getPollFilterEntityNameAction({
            //       filter_type: "entity_name",
            //       entity_type: entityType,
            //       page_type: pageType,
            //     })
            //   );
            // }
        });
    }, [mappings, dispatch]);

    useEffect(() => {
        if (id && getPollsData && pollPageTypeFilterData && pollDomainTypeData) {
            const {
                title,
                start_date,
                end_date,
                attributes,
                status,
                option,
                mappings: pollMappings,
            } = getPollsData;

            const firstMapping = Array.isArray(pollMappings) ? pollMappings[0] : null;
            setKeywordId(firstMapping?.keyword_id || []);

            setQuestion(title || "");
            setStartDate(start_date || null);
            setEndDate(end_date || null);
            setIsPublished(status || false);

            if (option?.length) {
                const sortedOptions = [...option]
                    .sort((a, b) => a.order - b.order)
                    .map((opt) => ({
                        id: opt.id,
                        value: opt.value,
                        order: opt.order,
                    }));
                setOptions(sortedOptions);
            }

            if (attributes?.length) {
                const attr = attributes[0];
                setVisibleDate(attr?.show_results_upto_days || null);

                if (pollDeviceFilterData?.device_type && attr.device_type) {
                    const matchedDeviceTypes = pollDeviceFilterData.device_type.filter(
                        (item) => attr.device_type.includes(item.id)
                    );
                    setDeviceType(matchedDeviceTypes);
                }

                if (attr.show) {
                    const matchedShow = ALLOW_ACCESS.filter((item) =>
                        attr.show.includes(item.id)
                    );
                    setShow(matchedShow.map((s) => s.id.toString()));
                }

                if (attr.allow_access) {
                    const matchedAccess = ALLOW_ACCESS.filter((item) =>
                        attr.allow_access.includes(item.id)
                    );
                    setAllowAccess(matchedAccess.map((a) => a.id.toString()));
                }
            }

            if (pollMappings?.length) {
                const mapped = pollMappings.map((mapItem) => {
                    const matchedDomain = pollDomainTypeData?.find(
                        (d) => d.id === mapItem.domain_id
                    );

                    // 🛠️ Fix entity_type to match Select option shape
                    const entityTypeObj = mapItem.entity_type
                        ? { id: mapItem.entity_type, value: mapItem.entity_type }
                        : "";
                    // 🛠️ Fix entity_name array
                    let matchedEntityNames = [];
                    if (Array.isArray(mapItem.entity_id)) {
                        matchedEntityNames = mapItem.entity_id
                            .filter((ent) => ent && ent.value)
                            .map((ent) => ({
                                label: ent.value, // what user sees
                                value: ent.value, // for react-select
                                entity_id: ent.id, // used for payload
                            }));
                    } else if (mapItem.entity_id && mapItem.entity_id.value) {
                        matchedEntityNames = [{
                            label: mapItem.entity_id.value,
                            value: mapItem.entity_id.value,
                            entity_id: mapItem.entity_id.id,
                        }];
                    }

                    if (mapItem?.page_type != null || mapItem?.page_type != undefined) {
                        dispatch(
                            getPollFilterEntityTypeAction({
                                filter_type: "entity_type",
                                page_type: mapItem?.page_type?.toLowerCase(),
                            })
                        );
                    }

                    if (mapItem?.page_type?.toLowerCase() === "college_detail_pages") {
                        let selectedEntityIds = [];
                        if (Array.isArray(mapItem.entity_id)) {
                            selectedEntityIds = mapItem.entity_id
                                .filter((ent) => ent && ent.id != null)
                                .map((ent) => ent.id);
                        } else if (mapItem.entity_id && mapItem.entity_id.id != null) {
                            selectedEntityIds = [mapItem.entity_id.id];
                        }

                        if (selectedEntityIds.length) {
                            dispatch(
                                getPollSubPageAction({
                                    filter_type: "sub_page",
                                    page_type: "college_detail_pages",
                                    entity_type: "college",
                                    entity_id: JSON.stringify(selectedEntityIds),
                                })
                            );
                        }
                    }

                    const matchedSubCategory = Array.isArray(mapItem.sub_page_ids)
                        ? mapItem.sub_page_ids
                            .filter((sub) => sub && sub.value)
                            .map((sub) => ({
                                label: sub.value, // what user sees in react-select
                                value: sub.value,
                                id: sub.id,
                            }))
                        : [];

                    const isSingleEntity = (mapItem?.page_type?.toLowerCase() === "news" && mapItem?.entity_type === "general");
                    const finalEntityName = isSingleEntity && matchedEntityNames.length > 0 ? matchedEntityNames[0] : matchedEntityNames;

                    return {
                        is_existing: true,
                        page_type: pollPageTypeFilterData?.page_type?.find(
                            (item) => item.id == mapItem?.page_type
                        ),
                        entity_type: entityTypeObj,
                        entity_name: finalEntityName,
                        sub_entity_id: mapItem.sub_entity_id,
                        domain: matchedDomain || "",
                        field3: mapItem.url || "",
                        sub_page: matchedSubCategory,
                        show_on_article: mapItem?.show_on_article,
                        show_on_college: mapItem?.show_on_college,
                    };
                });

                setMappings(mapped);
            }
        }
    }, [id, getPollsData, pollDeviceFilterData, pollPageTypeFilterData, pollDomainTypeData]);

    const handleSubmit = (e) => {
        e.preventDefault();
        const validationErrors = {};

        if (!question.trim())
            validationErrors.question = "Poll question is required";

        const filledOptions = options.filter((opt) =>
            typeof opt === "string" ? opt.trim() !== "" : opt?.value?.trim() !== ""
        );
        if (filledOptions.length < 2)
            validationErrors.options = "At least two options are required";

        if (!deviceType?.length)
            validationErrors.deviceType = "At least one device type is required";
        if (!show?.length)
            validationErrors.show = "At least one visibility option is required";
        if (!allowAccess?.length)
            validationErrors.allowAccess = "At least one access level is required";
        if (!startDate) validationErrors.startDate = "Start Date is required";
        if (!endDate) {
            validationErrors.endDate = "End Date is required";
        } else if (startDate && endDate < startDate) {
            validationErrors.endDate = "End Date cannot be earlier than Start Date";
        }

        mappings.forEach((map, index) => {
            if (!map.page_type)
                validationErrors[`page_type_${index}`] = "Page type is required";
            if (!map.domain)
                validationErrors[`domain_${index}`] = "Domain is required";
            if (map.field3) {
                if (!urlPattern.test(map.field3)) {
                    validationErrors[`url_${index}`] = "Invalid Careers360 URL";
                }
            }
        });

        setErrors(validationErrors);

        const hasOptionLengthError = Object.keys(optionLengthErrors).length > 0;

        if (Object.keys(validationErrors).length > 0 || hasOptionLengthError) {
            return;
        }

        const optionsPayload = options
            .filter((opt) =>
                typeof opt === "string" ? opt.trim() !== "" : opt?.value?.trim() !== ""
            )
            .map((opt, index) => ({
                id: index + 1,
                order: index + 1,
                value: typeof opt === "string" ? opt.trim() : opt.value.trim(),
            }));

        const attributesPayload = [
            {
                device_type: deviceType.map((d) => d.id),
                show: show.map((s) => Number(s)),
                allow_access: allowAccess.map((a) => Number(a)),
                start_date: startDate,
                end_date: endDate,
                show_results_upto_days: visibleDate ? Number(visibleDate) : 0,
            },
        ];

        const mappingsPayload = mappings.map((map) => ({
            page_type: map.page_type?.id,
            entity_type:
                (map.entity_type?.id
                    ? map.entity_type?.id
                    : map.page_type?.entity_type) || null,
            entity_id: Array.isArray(map.entity_name)
                ? map.entity_name.map(e => Number(e.entity_id))
                : map.entity_name ? [Number(map.entity_name.entity_id)] : [],
            sub_entity_id: map.sub_entity_id?.id || null,
            domain_id: map.domain?.id || 1,
            url: map.field3 || "",
            show_on_article: map.show_on_article || false,
            show_on_college: map.show_on_college || false,
            sub_page_ids: map.sub_page?.map((sp) => Number(sp.id)) || [],
            keyword_id: [],
        }));

        const payload = {
            title: question.trim(),
            status: isPublished ? 1 : 0,
            start_date: startDate,
            end_date: endDate,
            option: optionsPayload,
            attributes: attributesPayload,
            mappings: mappingsPayload,
            updated_by: user?.data.id,
        };
        if (showWarning) {
            return
        }
        if (id) {
            dispatch(putPollsAction({ ...payload, id }));
        } else {
            dispatch(postPollsAction({ ...payload, created_by: user?.data.id }));
        }
    };
    useEffect(() => {
        if (message) {
            setTimeout(() => {
                if ((putPollData || postPollsData) && message) {
                    dispatch(clearMessage());
                    navigate(`/cms/polls`);
                } else {
                    dispatch(clearMessage());
                }
            }, 3000);
        }
    }, [message]);

    return (
        <>
            <h4>Poll Management</h4>

            <div className="custom_breadcrumb">
                <ul className="custom_breadcrumb_ul">
                    <li className="custom_breadcrumb_list">
                        <a href="/cms" className="sub_nan_anchor">
                            Home
                        </a>
                    </li>
                    <li className="custom_breadcrumb_list">
                        <span>
                            <FiChevronRight />
                        </span>
                    </li>
                    <li className="custom_breadcrumb_list">
                        <a href="/cms/polls" className="sub_nan_anchor">
                            Manage Poll
                        </a>
                    </li>
                    <li className="custom_breadcrumb_list">
                        <span>
                            <FiChevronRight />
                        </span>
                    </li>
                    <li className="custom_breadcrumb_list custom_breadcrumb_list_active">
                        {id ? "Edit Poll" : "Add Poll"}
                    </li>
                </ul>
            </div>

            <div className={"notification_popup"}>
                {message && (
                    <Alert
                        severity={postPollsError || putPollError ? `error` : `success`}
                    >
                        {" "}
                        {message?.message
                            ? JSON.stringify(message?.message)
                            : JSON.stringify(message)}
                    </Alert>
                )}
            </div>

            <div>
                <ManagePollForm
                    question={question}
                    setQuestion={setQuestion}
                    endDate={endDate}
                    setEndDate={setEndDate}
                    startDate={startDate}
                    setStartDate={setStartDate}
                    visibleDate={visibleDate}
                    setVisibleDate={setVisibleDate}
                    isPublished={isPublished}
                    setIsPublished={setIsPublished}
                    showOnArticle={showOnArticle}
                    setShowOnArticle={setShowOnArticle}
                    showOnCollege={showOnCollege}
                    setShowOnCollege={setShowOnCollege}
                    deviceType={deviceType}
                    setDeviceType={setDeviceType}
                    show={show}
                    setShow={setShow}
                    allowAccess={allowAccess}
                    setAllowAccess={setAllowAccess}
                    options={options}
                    setOptions={setOptions}
                    mappings={mappings}
                    setMappings={setMappings}
                    setWarning={setWarning}
                    showWarning={showWarning}
                    errors={errors}
                    setErrors={setErrors}
                    handleSubmit={handleSubmit}
                    getPollsData={getPollsData}
                    optionLengthErrors={optionLengthErrors}
                    setOptionLengthErrors={setOptionLengthErrors}
                    urlPattern={urlPattern}
                />

                {getPollsData && (
                    <div className="mx-3 mt-5" style={{ color: "#8A7F7F" }}>
                        <h6>
                            Updated on {formatDateFor(getPollsData?.updated_at)} by{" "}
                            {getPollsData?.username}
                        </h6>
                    </div>
                )}
            </div>
        </>
    );
};
